<template>
  <section>
    <v-container fluid fill-height grid-list-xl align-content-start>
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card
            color="orange"
            title="Register Customer Owned Accounts"
            text="List of all customer-owned AWS account requests">
            <v-layout justify-center wrap>
              <v-flex xs12 sm4 md4 offset-md8>
                <v-text-field
                  v-model="search"
                  label="Search"
                  single-line
                  hide-details
                  append-icon="search"
                  @keyup.enter="searchRequests"
                />
              </v-flex>
            </v-layout>

            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="orange"
              class="mb-4"
            />

            <v-alert v-if="error" type="error" dense>
              {{ error }}
            </v-alert>

            <v-data-table
              :headers="headers"
              :items="requests"
              :pagination.sync="pagination"
              class="elevation-0"
              hide-default-footer
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td>
                    <v-icon small @click="viewRequest(props.item)">
                      visibility
                    </v-icon>
                  </td>
                  <td>{{ props.item.opportunityId }}</td>
                  <td>{{ props.item.customerName }}</td>
                  <td v-html="formatAwsAccountIds(props.item.awsAccountIds)"></td>
                  <td>{{ props.item.supportingPdl }}</td>
                  <td>{{ props.item.contactEmail }}</td>
                  <td>{{ props.item.contactName }}</td>
                  <td>{{ props.item.requestManagedServices === 'true' ? 'Yes' : 'No' }}</td>
                  <td>{{ props.item.status || 'Pending' }}</td>
                </tr>
              </template>
            </v-data-table>
            <div class="text-xs-center mt-3" >
              <v-btn :disabled="!nextPageKey" small @click="showNextData">LOAD MORE...</v-btn>
            </div>
            <div v-if="!isLoading && requests.length === 0" class="text-center mt-4">
              <v-icon large color="grey">mdi-information-outline</v-icon>
              <p class="mt-3">No customer owned AWS account requests were found.</p>
            </div>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="showDialog" max-width="700">
      <v-card v-if="selectedRequest">
        <v-card-title>
          <span class="headline">Request details</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-list two-line>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Opportunity ID</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.opportunityId }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Customer Name</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.customerName }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>AWS Account IDs</v-list-tile-title>
                <v-list-tile-sub-title v-html="formatAwsAccountIds(selectedRequest.awsAccountIds)"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Supporting PDL</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.supportingPdl }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Contact</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.contactName }} — {{ selectedRequest.contactEmail }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Managed Services Requested</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.requestManagedServices === 'true' ? 'Yes' : 'No' }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar v-if="selectedRequest.requestManagedServices === 'true'">
              <v-list-tile-content>
                <v-list-tile-title>WBS Code</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.wbsCode }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <!-- <v-list-tile avatar v-if="selectedRequest.requestManagedServices === 'true'">
              <v-list-tile-content>
                <v-list-tile-title>WBS Code</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.wbsCode }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile> -->

            <v-list-tile avatar v-if="selectedRequest.requestManagedServices === 'true'">
              <v-list-tile-content>
                <v-list-tile-title>Target Deployment Date</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.targetDeploymentDate }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Customization Description</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.customizationDescription }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <p v-if="selectedRequest.status === 'Approved'" class="mr-4 green--text">This request has been approved.</p>
          <!-- <v-btn
            v-if="selectedRequest.status === 'Pending'"
            text color="secondary" @click="approveRequest">Approved</v-btn> -->
          <v-btn
            v-if="selectedRequest.status === 'In Progress'"
            text color="secondary" @click="completeRequest">Complete</v-btn>
          <v-btn text color="primary" @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CustomerOwnedAwsAccountsList',
  data () {
    return {
      search: '',
      showDialog: false,
      headers: [
        { text: 'Actions', value: '', sortable: false },
        { text: 'Opportunity ID', value: 'opportunityId' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'AWS Account IDs', value: 'awsAccountIds' },
        { text: 'Supporting PDL', value: 'supportingPdl' },
        { text: 'Contact Name', value: 'contactName' },
        { text: 'Contact Email', value: 'contactEmail' },
        { text: 'Managed Services', value: 'requestManagedServices' },
        { text: 'Status', value: 'status' }
      ],
      pagination: {
        rowsPerPage: 10,
        sortBy: 'customer_owned_id',
        descending: true
      }
    }
  },
  computed: {
    ...mapState('admin/registerCustomerOwnedAccts', [
      'requests',
      'isLoading',
      'selectedRequest',
      'nextPageKey'
    ])
  },
  async mounted () {
    console.log('Mounted CustomerOwnedAwsAccountsList, fetching requests...')
    this.fetchRequests({ nextPageKey: '' })
  },
  methods: {
    ...mapActions('admin/registerCustomerOwnedAccts', [
      'fetchRequests'
    ]),
    viewRequest (request) {
      this.$store.commit('admin/registerCustomerOwnedAccts/setSelectedRequest', request)
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
    },
    async approveRequest () {
      console.log('Approving request with ID:', this.selectedRequest.customer_owned_id)
      const parameters = {
        requestId: this.selectedRequest.customer_owned_id,
        status: 'Approved'
      }
      parameters['emailData'] = {
        template: 'managed-svcs-approve',
        send_to: this.selectedRequest.requestorEmail,
        opportunity_id: this.selectedRequest.opportunityId,
        aws_account_id: this.selectedRequest.awsAccountIds.map(item => item.aws_account_id).join(',')
      }
      await this.$store.dispatch('admin/registerCustomerOwnedAccts/approveRequest', parameters)
      this.closeDialog()
      this.fetchRequests({ nextPageKey: '' })
    },
    async completeRequest () {
      console.log('Completing request with ID:', this.selectedRequest.customer_owned_id)
      const parameters = {
        requestId: this.selectedRequest.customer_owned_id,
        status: 'Completed'
      }
      parameters['emailData'] = {
        template: 'managed-svcs-completed',
        send_to: this.selectedRequest.requestorEmail,
        opportunity_id: this.selectedRequest.opportunityId,
        aws_account_id: this.selectedRequest.awsAccountIds.map(item => item.aws_account_id).join(',')
      }
      await this.$store.dispatch('admin/registerCustomerOwnedAccts/approveRequest', parameters)
      this.closeDialog()
      this.fetchRequests({ nextPageKey: '' })
    },
    searchRequests () {
      this.fetchRequests({ search: { opportunityId: this.search } })
    },
    showNextData () {
      this.pagination.rowsPerPage = this.requests.length + this.pagination.rowsPerPage
      let parameter = {}
      if (this.nextPageKey) {
        parameter.nextPageKey = this.nextPageKey
      }
      if (this.search) {
        parameter.search = { opportunityId: this.search }
      }
      this.fetchRequests(parameter)
    },
    formatAwsAccountIds (awsAccountIds) {
      let accountItems = awsAccountIds

      if (typeof accountItems === 'string') {
        try {
          accountItems = JSON.parse(accountItems)
        } catch (e) {
          return accountItems
        }
      }
      if (!Array.isArray(accountItems)) {
        return ''
      }

      return accountItems
        .map(item => (item.aws_account_id || item.accountId || '').toString().trim())
        .filter(Boolean)
        .join(', ')
    }
  }
}
</script>

<style scoped lang="scss">
.text-center {
  text-align: center;
  padding: 24px 0;
}
</style>
